import "./Skills.css"
import skil from "./skill.webp"

const Skill = ()=>
{
    return(
        <div className="skill">
            <h1>My <span>Skills</span></h1>
            <div className="aa">
                <div className="aboutone">
                    <p>1️⃣ Programming Languages :  <b> Java, JavaScript</b> </p>
                    <p>2️⃣ Frameworks / Libraries : <b> React.js, Node.js, Express.js</b> </p>
                    <p>3️⃣ Databases : <b> MongoDB</b></p>
                    <p>4️⃣ Data Structures & Algorithms : <b> Arrays, Strings, Linked List, Stack, Queue, Trees, Recursion, Sorting, Searching</b></p>
                    <p>5️⃣ Other Skills: <b> REST APIs, Responsive Design, Debugging</b></p>
                </div>
                <div className="abouttwo">
                    <img src={skil} alt="" />
                </div>     
            </div> 
        </div>
    )
}

export default Skill